import React from 'react';
import AppContainer from '../app-container';
import LocalizedStrings from '../../localization/strings';
import DocumentTitle from 'react-document-title';

export default class PaymentRejectedPageContainer extends AppContainer {
    render() {
        return (
            <DocumentTitle title={this.getDocumentTitle(LocalizedStrings.paymentRejected)}>
                <div className="page-section">
                    <div className="container">
                        <h1 className="title">
                            <span>{LocalizedStrings.paymentRejected}</span>
                        </h1>
                        <div>
                            {LocalizedStrings.paymentRejectedText}
                        </div>
                    </div>
                </div>
            </DocumentTitle>
        )
    }
}


// WEBPACK FOOTER //
// ./src/js/containers/pages/payment-rejected-page-container.js